import React, { useEffect, useMemo, useState } from "react";
import searchicon from "../../assets/images/search-icon.svg";
import useChatList from "hooks/useChatList";
import useChatById from "hooks/useChatById";
import { Link, useSearchParams } from "react-router-dom";
import useCurrentUser from "hooks/useCurrentUser";
import ChatBox from "./ChatBox";
import ChatList from "./ChatList";
import star from "assets/images/star.svg";
import { Nav } from "react-bootstrap";
import notify from "../../assets/images/Notification.png";

const ChatWindow = () => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const [chatId, setChatId] = useState(null);
  const [currentMsg, setCurrentMsg] = useState("");
  const [msgList, setMsgList] = useState([]);
  const [chatLength, setChatLength] = useState({ skip: 0, limit: 20 });
  const [messageLength, setMessageLength] = useState({ skip: 0, limit: 5000 });
  const [query, setQuery] = useState("");

  const { user, token, socket } = useCurrentUser();
  const { chatList } = useChatList(chatLength, msgList);
  const { chatMessagesData } = useChatById({ ...messageLength, chatId });

  const { totalChats, chats: chatsData } = chatList;
  const { chat: chatDetails, messages } = chatMessagesData || {};

  // 🟢 Handle receiving messages (only for active chat)
  useEffect(() => {
    if (!socket || !chatId) return;

    const handleReceiveMessage = (res) => {
      if (res.chatId === chatId) {
        setMsgList((prev) => [...prev, res]);
      }
    };

    socket.on("receiveMessage", handleReceiveMessage);

    return () => {
      socket.off("receiveMessage", handleReceiveMessage);
    };
  }, [socket, chatId]);

  // 🟢 Handle socket connect/disconnect logs (optional)
  useEffect(() => {
    if (!socket) return;
    socket.on("connect", () => console.log("Socket connected:", socket.id));
    socket.on("disconnect", () => console.log("Socket disconnected"));
    return () => {
      socket.off("connect");
      socket.off("disconnect");
    };
  }, [socket]);

  useEffect(() => setChatId(id), [id]);
  useEffect(() => setMsgList(messages?.reverse() || []), [messages]);

  // 🟢 Send message (handles admin/client/pilot dynamically)
  const handleSend = (e) => {
    e.preventDefault();
    if (!currentMsg.trim()) return;

    let receiverId = null;

    if (chatDetails?.clientId && chatDetails?.pilotId) {
      receiverId =
        user.roleType === "CLIENT"
          ? chatDetails?.pilotId?._id
          : chatDetails?.clientId?._id;
    } else if (chatDetails?.adminId && chatDetails?.pilotId) {
      receiverId =
        user.roleType === "ADMIN"
          ? chatDetails?.pilotId?._id
          : chatDetails?.adminId?._id;
    } else if (chatDetails?.adminId && chatDetails?.clientId) {
      receiverId =
        user.roleType === "ADMIN"
          ? chatDetails?.clientId?._id
          : chatDetails?.adminId?._id;
    }

    const messageData = {
      chatId,
      senderId: user._id,
      receiverId,
      message: currentMsg,
    };

    socket.emit("sendMessage", messageData, (response) => {
      if (response?.message) {
        setMsgList((prev) => [...prev, response.message]);
      }
    });

    setCurrentMsg("");
  };

  // 🟢 Filter by search name dynamically (for all role types)
  const filteredItems = useMemo(() => {
    if (!chatsData?.length) return [];
    return chatsData.filter((item) => {
      const userData =
        user?.roleType === "CLIENT"
          ? item?.pilotId || item?.adminId
          : user?.roleType === "PILOT"
            ? item?.clientId || item?.adminId
            : item?.pilotId || item?.clientId;

      return userData?.fullName
        ?.toLowerCase()
        ?.includes(query?.toLowerCase());
    });
  }, [chatsData, query, user]);

  const handleQryChange = (e) => setQuery(e.target.value);

  const handleViewMore = () => {
    setChatLength((prev) => ({ ...prev, limit: prev.limit + 10 }));
  };

  return (
    <>
      {totalChats > 0 ? (
        <div>
          <div className="container-box">
            <div className="top-head d-flex flex-wrap justify-content-between align-items-center">
              <h2>Message</h2>
            </div>
            <div className="mt-2 chat-page">
              <section className="message-area">
                <div>
                  <div className="row">
                    <div className="col-12">
                      <div className="chat-area">
                        <div className="chatlist">
                          <div className="modal-dialog-scrollable">
                            <div className="modal-content">
                              <div className="chat-header">
                                {chatsData?.length > 0 && (
                                  <div className="search-bar">
                                    <div className="search-container">
                                      <input
                                        type="text"
                                        placeholder="Search"
                                        className="form-control"
                                        onChange={handleQryChange}
                                      />
                                      <div className="search-button">
                                        <img alt="" src={searchicon} />
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div className="modal-body p-0">
                                <div className="chat-lists">
                                  <ChatList
                                    chatsData={filteredItems}
                                    totalChats={totalChats}
                                    user={user}
                                    chatId={chatId}
                                    handleViewMore={handleViewMore}
                                    query={query}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <ChatBox
                          chatDetails={chatDetails}
                          user={user}
                          messages={msgList}
                          setCurrentMsg={setCurrentMsg}
                          handleSend={handleSend}
                          currentMsg={currentMsg}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      ) : (
        <div className="container-box">
          <div className="top-head d-flex flex-wrap justify-content-between align-items-center bg-white">
            <h2>Chat</h2>
            <Nav.Link as={Link} to="/notification" href="/notification">
              <div className="position-relative">
                <img src={notify} alt="" />
                <span className="position-absolute badge-custom rounded-circle">
                  <span className="visually-hidden">New alerts</span>
                </span>
              </div>
            </Nav.Link>
          </div>
          <div className="outer-white job-details-page">
            <div className="disaster-card mx-auto text-center">
              <div className="alert-distaster mx-auto">
                <img src={star} alt="star" />
              </div>
              <h2>No active chat discussions!</h2>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ChatWindow;
